import React from 'react';

import type { GridCellParams } from '@mui/x-data-grid-premium';
import type { DocumentStatusRow } from 'src/components/reports/report-detail/GridStatusCell';
import { DocumentStatusRowControl } from 'src/components/reports/report-detail/GridStatusCell';
import { useCellStyles } from 'src/components/reports/report-detail/ReportCell';

export interface PartyDocumentStatusRow extends DocumentStatusRow {
  id: UUID;
}

/**
 * Party rows are plain `Document`s, so the document id is the row `id`. The report
 * `GridStatusCell` reads `documentId`, which only report rows carry.
 */
export function PartyDocumentStatusCell<T extends PartyDocumentStatusRow>({
  row,
}: Pick<GridCellParams<T>, 'row'>): JSX.Element {
  const cellClasses = useCellStyles();

  return (
    <div className={cellClasses.cell}>
      <DocumentStatusRowControl documentId={row.id} row={row} />
    </div>
  );
}
